import { createAsyncThunk } from "@reduxjs/toolkit";
import { postLoginService } from "../../Services";

// Merchant analytics for ONE section (earnings|orders|deals) with its own period/custom range.
// arg = { section, period, from, to }. Each section is fetched + filtered independently.
export const getMerchantAnalytics = createAsyncThunk(
  "dashboard/getMerchantAnalytics",
  async (arg, { rejectWithValue }) => {
    const { section = "all", period, from, to, year, dealLimit, dealStatus } = arg || {};
    try {
      const params = {};
      if (section) params.section = section;
      if (section === "monthly") {
        if (year) params.year = year;
      } else {
        if (period) params.period = period;
        if (period === "custom") {
          if (from) params.from = from;
          if (to) params.to = to;
        }
        // Most Sold Deals table filters.
        if (section === "deals") {
          if (dealLimit) params.dealLimit = dealLimit;
          if (dealStatus) params.dealStatus = dealStatus;
        }
      }
      const response = await postLoginService.get(`/api/merchants/me/analytics`, { params });
      if (response?.success) {
        return { section, payload: response.data };
      }
      return rejectWithValue(response?.message || "Failed to fetch analytics");
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || "Failed to fetch analytics"
      );
    }
  }
);

// NOTE: getMerchantEarningsDashboard (GET /api/merchants/me/earnings-dashboard) was removed — it
// was never dispatched by any page. The dashboard is served entirely by getMerchantAnalytics above.
// The backend endpoint still exists; nothing in the frontend calls it.
